export default {
  common: {
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    close: "Close",
    edit: "Edit",
    retry: "Retry",
    comingSoon: "Coming soon",
  },
  statuses: {
    new: "New",
    draft: "Draft",
    active: "Active",
    suspended: "Suspended",
    discontinued: "Discontinued",
    pending: "Pending",
    alert: "Alert",
    voided: "Voided",
  },
  entityTypes: {
    primary: "Primary",
    shipping: "Shipping",
    packaging: "Packaging",
    product: "Product",
  },
  list: {
    titleProducts: "Products",
    titlePackaging: "Packaging",
    subtitleProducts: "Manage and control products used in L'Authorize.",
    subtitlePackaging: "Manage and control packaging used in L'Authorize.",
    addProduct: "Add product",
    addPackaging: "Add packaging",
    emptyProducts: "To see products in the list, first add them.",
    emptyPackaging: "To see packaging in the list, first add it.",
    packagingActivatedNotice: "Packaging activated. You can now create a Digital Label and a Declaration of Conformity.",
    productLabelsLoadFailed: "Failed to load product labels. Digital label actions are unavailable until this succeeds.",
    docFullName: "Declaration of Conformity",
    columns: {
      sku: "SKU",
      name: "Name",
      type: "Type",
      activeFrom: "Active from",
      activeTill: "Active till",
      status: "Status",
      comments: "Comments",
      actions: "Actions",
      packageType: "Package Type",
      activeFromPackaging: "Active From",
      label: "Label",
      doc: "DoC",
    },
    actions: {
      view: "View",
      edit: "Edit",
      complete: "Complete",
      documents: "Documents",
      digitalLabel: "Digital label",
      changeStatus: "Change status",
      delete: "Delete",
      activatePackaging: "Activate packaging",
      restore: "Restore",
      void: "Void",
    },
    cells: {
      resume: "Resume",
      preview: "Preview",
      open: "Open",
      create: "Create",
      labelAria: "{{action}} label, {{status}}",
      openLabel: "Open label",
      createLabel: "Create label",
      createLabelUnavailable: "Create label (unavailable)",
      openDoc: "Open Declaration of Conformity",
      createDoc: "Create Declaration of Conformity",
      createDocUnavailable: "Create Declaration of Conformity (unavailable)",
      labelUnavailableReason: "You can create a Digital Label once this packaging is Active.",
      docUnavailableReason: "You can create a Declaration of Conformity once this packaging is Active.",
      activateHint: "Activate it from the actions menu.",
    },
    filters: {
      search: "Search",
      searchProducts: "Search by SKU / name",
      searchPackaging: "Search by Packaging ID / name",
      packagingType: "Packaging type",
      store: "Store",
      status: "Status",
      dateRange: "Date range",
      activePeriodFrom: "Active period from",
      activePeriodTo: "Active period to",
    },
    changeStatus: {
      title: "Change product status",
      selectStatus: "Select status",
      placeholder: "Choose status...",
    },
    createDigitalLabel: {
      title: "Create digital label",
      ppwrTitle: "Packaging label (PPWR)",
      ppwrDescription: "Create a digital label for packaging materials, recycling and circularity information.",
      gpsrTitle: "Product label (GPSR)",
      gpsrDescription: "Create a digital label for product safety, manufacturer and compliance information.",
    },
    deleteProduct: {
      title: "Delete product",
      description: "Are you sure you want to delete product \"{{name}}\"? This action cannot be undone.",
    },
    details: {
      titleProduct: "Product details",
      titlePackaging: "Packaging details",
      descriptionProduct: "View product configuration and activity period",
      descriptionPackaging: "View packaging configuration and activity period",
      lastUpdated: "Last updated",
    },
  },
  labelStatuses: {
    draft: "Draft",
    published: "Published",
    createDigitalLabel: "Create digital label",
    viewDraft: "View draft",
    viewDigitalLabel: "View digital label",
  },
  labelDrawer: {
    packagingLabelTitle: "Packaging Label",
    productLabelTitle: "Product Label (GPSR)",
    packagingLabelNotFound: "Packaging label not found.",
    packagingLabelLoadFailed: "Failed to load packaging label.",
    productLabelNotFound: "Product label not found.",
    productLabelLoadFailed: "Failed to load product label.",
    productLabelIdRequired: "A Product Label id is required before printing.",
    qrNotAvailable: "A digital label QR code is not available yet.",
    fibreLoadFailed: "Failed to load fibre components.",
    loading: "Loading label…",
    unableToLoad: "Unable to load label",
    fit: "Fit",
    expandAria: "Expand label preview",
    expand: "Expand",
    copied: "Copied",
    copyLink: "Copy link",
    preparingPrint: "Preparing print…",
    printLabel: "Print label",
    closeFullPreview: "Close full-size preview",
    ppwrPrintFailed: "Unable to prepare the packaging label for printing. Please try again.",
    gpsrPrintFailed: "Unable to prepare the GPSR label for printing. Please try again.",
    printPropsRequired: "Printable label props are required.",
    printUnavailable: "Print is not available in this browser.",
  },
  payment: {
    noData: "No payment data found.",
    checking: "Checking subscription status... ({{attempt}}/{{total}})",
    unexpected: "An unexpected error occurred. Please try again later or contact support if the issue persists",
    complete: "Your subscription has been activated. Thank you for your payment!",
    failed: "We couldn't process your payment. Please check your card details or try a different payment method",
    cancelled: "Payment was cancelled. You can try again when ready.",
    processing: "Payment is still processing. Please wait...",
    error: "Error",
  },
  activation: {
    errors: {
      partial: "The packaging was finalized but not activated. Select Activate to try again.",
      permission: "You don't have permission to activate this packaging. Contact your manager.",
      generic: "Couldn't activate the packaging. Try again.",
      notFinalized: "The packaging couldn't be completed, so it wasn't activated. Try again.",
      unconfirmed: "The packaging was activated, but its status couldn't be refreshed. Reload the page to check it.",
      loadFailed: "Couldn't load the packaging. Try again.",
      notActivatable: "This packaging can't be activated. Its status is {{status}}.",
      unknownStatus: "unknown",
    },
    readiness: {
      packagingDetails: "Packaging details",
      name: "Name",
      packagingType: "Packaging type",
      intendedEndUser: "Intended end user",
      mainElement: "Main element",
      totalWeight: "Total weight",
      dimensions: "Dimensions",
    },
    thisPackaging: "This packaging",
    completeBeforeActivating: "Complete these details before activating: {{fields}}.",
    willBecomeActive: "“{{name}}” will become Active, so you can create Digital Labels and Declarations of Conformity for it.",
    noDraftAgain: "Active packaging can't be saved as a draft again.",
    completeTitle: "Complete packaging details",
    activateTitle: "Activate packaging?",
    completePackaging: "Complete packaging",
    activating: "Activating…",
    activate: "Activate",
    openPackagingList: "Open Packaging list",
    notice: {
      documentLabel: "a Digital Label",
      documentDoc: "a Declaration of Conformity",
      documentsNeedActive: "Digital Labels and Declarations of Conformity can only be created for Active packaging.",
      activateToCreate: "Activate packaging to create {{documentName}}",
      activatingConfirms: "Activating confirms that the packaging details are final.",
      mustBeActive: "Packaging must be Active",
      completeFirst: "Complete the packaging first.",
      managerHowTo: "To activate it, open the Packaging list, select ⋯ → Change status → Active.",
      voidedTitle: "This packaging is voided",
      voidedBody: "Restore it from the Packaging list, then activate it to create documents.",
      packagingIsStatus: "This packaging is {{status}}.",
      contactManager: "Contact your manager to change its status.",
      unknownTitle: "Packaging status unavailable",
      unknownBody: "We couldn't confirm this packaging's status. Reload the page to try again.",
    },
  },
};
